import React, { Component } from 'react';
import { Field, FieldArray, formValueSelector } from 'redux-form';
import { FormGroup, ControlLabel, FormControl } from 'react-bootstrap';
import { connect } from 'react-redux';

import TagCell from '../../tags/TagCell';

import FormError from '../../../forms/FormError';

import FormField from '../../../forms/FormField';
import { postTag, getTags, getTagById } from '../../../../api/api';

const TagOptions = ({ options, handlePostNewTag, handleTagSelect, showOptions, activeOptionIndex, color }) => {
  if (!showOptions || !options || !options.length) return false;
  const handleClick = o => {
    if (o.newTag) {
      return handlePostNewTag(o);
    }
    return handleTagSelect(o);
  }
  const getStyle = (activeOptionIndex, index) => {
    if (activeOptionIndex === index) {
      return { padding: '5px', color: 'white', backgroundColor: color || '#C82324' }
    }
    return {};
  }
  return (
    <div className="tag-dropdown">
      {options.map((o, index) => <div key={o.value} style={getStyle(activeOptionIndex, index)} onClick={() => handleClick(o)}>{o.label}</div>)}
    </div>
  )
}

class Tag extends Component {
  constructor(props) {
    super(props);
    this.loadTag = this.loadTag.bind(this);
    this.state = { tag: null, error: null };
    if (!props.value) return
    this.loadTag(props.value);
  }
  componentDidUpdate(prevProps) {
    if (prevProps.value === this.props.value) return;
    this.loadTag();
  }
  async loadTag() {
    const { value } = this.props;
    if (!value) {
      this.setState({ tag: null, error: null });
      return
    }
    try {
      const tag = await getTagById(value);
      this.setState({ tag, error: null });
    } catch (error) {
      this.setState({ tag: null, error });
    }
  }
  render() {
    const { value, index, handleRemoveTag, readOnly } = this.props;
    const { tag } = this.state;
    if (!value || !tag) return false;
    return (
      <span className="asset-tag-item">
        <TagCell tag={tag} />
        {!readOnly &&
          <span onClick={() => handleRemoveTag(index)} className="ti ti-close" />
        }
      </span>
    )
  }
}

class TagSelectComponent extends Component {
  constructor(props) {
    super(props);
    this.state = { options: [], value: '', showOptions: false, activeOptionIndex: 0 };
    this.inputTimeout = null;
  }
  render() {
    const {
      readOnly,
      label,
      handleAddTag,
      handleRemoveTag,
      values,
      color
    } = this.props;

    const { options, value, showOptions, activeOptionIndex } = this.state;
    const meta = {};

    const handlePostNewTag = async (o) => {
      const { value } = o || {};
      const { _id } = await postTag({ value, color });
      handleAddTag(_id);
    }

    const handleChange = async e => {
      const { value } = e.target || {};
      this.setState({ value })

      if (value.length < 3) {
        this.setState({ options: [], activeOptionIndex: 0 });
        return;
      }

      const tags = await getTags(value);

      const options = (tags || []).map(({ value, _id }) => ({
        value: _id,
        label: value
      }))

      if (!options.some(o => o.label.trim().toLowerCase() === value.trim().toLowerCase())) {
        options.unshift({ label: `New tag "${value}"`, value, newTag: true });
      }

      if (options.length - 1 < activeOptionIndex) {
        this.setState({ options, activeOptionIndex: 0 });
        return;
      }
      this.setState({ options });
    }

    const handleTagSelect = tag => {
      const { value } = tag || {};
      handleAddTag(value);
    }

    const handleInputBlur = () => {
      clearTimeout(this.inputTimeout)
      this.inputTimeout = setTimeout(() => this.setState({ showOptions: false }), 300);
    }
    const handleInputFocus = () => {
      clearTimeout(this.inputTimeout)
      this.setState({ showOptions: true });
    }

    const handleKeyDown = e => {
      const specialKeys = [9, 13, 38, 40]; // [tab, enter, up, down]

      const { keyCode } = e;

      if ((!options || !options.length) && activeOptionIndex !== 0) {
        this.setState({ activeOptionIndex: 0 });
        return;
      }

      if (!specialKeys.some(c => c === keyCode)) return;

      e.preventDefault();

      if (keyCode === 9 || keyCode === 13) {
        const selectedOption = options[activeOptionIndex];
        if (!selectedOption) return;
        if (selectedOption.newTag) {
          return handlePostNewTag(selectedOption);
        }
        return handleTagSelect(selectedOption);
      }

      if (keyCode === 38 && options && options.length && activeOptionIndex > 0) {
        this.setState({ activeOptionIndex: activeOptionIndex - 1 });
        return;
      }

      if (keyCode === 40 && options && options.length && activeOptionIndex < options.length - 1) {
        this.setState({ activeOptionIndex: activeOptionIndex + 1 });
        return;
      }
    }

    return (
      <FormGroup controlId="value">
        <div className="form-container">
          {(values || []).map((v, index) => (
            <Tag
              value={v}
              handleRemoveTag={handleRemoveTag}
              readOnly={readOnly}
              index={index}
            />
          ))}
          {!readOnly && (
            <div className="form-group dropdown">
              <FormControl
                value={this.state.value}
                type="text"
                onChange={handleChange}
                onBlur={handleInputBlur}
                onFocus={handleInputFocus}
                onKeyDown={handleKeyDown}
                autoComplete="off"
              />
              <TagOptions
                options={options}
                handlePostNewTag={handlePostNewTag}
                handleTagSelect={handleTagSelect}
                showOptions={showOptions}
                activeOptionIndex={activeOptionIndex}
                color={color}
              />
              {meta.touched &&
                (meta.error || meta.warning) &&
                <FormError message={meta.error || meta.warning} />}
            </div>
          )}

        </div>
      </FormGroup>
    )
  }
}

const selector = formValueSelector('asset-form');


const mapState = (state, props) => {
  const name = props.isRoot ? 'tags' : props.name;
  const values = selector(state, name);
  return {
    values,
  };
};

const TagSelect = connect(mapState)(TagSelectComponent);

const RenderFieldsArray = ({ fields, readOnly, name, isRoot, color, ...rest }) => {
  const handleAddTag = tag => {
    fields.push(tag);
  }
  const handleRemoveTag = index => {
    fields.remove(index)
  }

  return (
    <TagSelect
      handleAddTag={handleAddTag}
      handleRemoveTag={handleRemoveTag}
      readOnly={readOnly}
      name={name}
      isRoot={isRoot}
      color={color}
    />
  )
}


class AssetTags extends Component {

  render() {
    const { readOnly, input, label, isRoot, color, labelStyle, rootName } = this.props;
    const { name } = input || {};
    return (
      <div>
        <h4 style={labelStyle || {}}>{label || 'Tags'}</h4>
        <FieldArray name={isRoot ? 'tags' : rootName} component={RenderFieldsArray} props={{ readOnly, isRoot, name, color }} />
      </div>
    )
  }
}

export default AssetTags;



// WEBPACK FOOTER //
// ./src/components/routes/assets/asset-form/AssetTags.js